import React from 'react';
import { connect } from 'react-redux';
import { withCookies, Cookies } from 'react-cookie';
import PropTypes from 'prop-types';

import {
  ACCESS_ENABLER_OBJ,
  configTVE,
  configTempPass,
} from 'lib/tve';

const mapStateToProps = ({ router, tve }) => ({
  authenticated: tve.authenticated,
  domain: router.domain,
  hasTempPass: tve.hasTempPass,
  resourceID: tve.resourceID,
  selectedProvider: tve.provider,
  tempPassProviderID: tve.tempPassProviderID,
});

class TempPass extends React.Component {
  // Interval reference for checking tempPass authorization
  tempPassInterval = null;

  static propTypes = {
    authenticated: PropTypes.oneOf([null, false, true]),
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    domain: PropTypes.string.isRequired,
    hasTempPass: PropTypes.bool,
    tempPassProviderID: PropTypes.string,
  };

  static defaultProps = {
    authenticated: null,
    hasTempPass: false,
    tempPassProviderID: null,
  };

  shouldComponentUpdate() {
    const { tempPassProviderID } = this.props;
    return tempPassProviderID !== null;
  }

  componentDidUpdate(prevProps) {
    const {
      authenticated: hadAuth,
      hasTempPass: hadTempPass,
    } = prevProps;

    const {
      authenticated,
      cookies,
      domain,
      hasTempPass,
    } = this.props;

    // User is not authenticated
    if (hadAuth === null && authenticated === false) {
      // TempPass not yet in use, check availability
      if (typeof cookies.get(configTempPass.checkName) === 'undefined') {
        this.tempPassCheck();
      }
    // User is now authenticated with TempPass
    } else if (authenticated && hadTempPass === false && hasTempPass === true) {
      // Set tempPass cookie
      this.tempPassSetCookie();

      // Check authorization regularly as a backup to the countdown
      if (!this.tempPassInterval) {
        const { resourceID } = configTVE[domain];

        this.tempPassInterval = setInterval(() => {
          window[ACCESS_ENABLER_OBJ].checkAuthorization(resourceID);
        }, configTempPass.checkInterval * 1000);
      }
    } else if (hadTempPass === true && hasTempPass === false) {
      clearInterval(this.tempPassInterval);
    }
  }

  componentWillUnmount() {
    clearInterval(this.tempPassInterval);
  }

  /**
   * Store the tempPass expiration in a cookie, this is for display purposes only
   */
  tempPassSetCookie = () => {
    const { cookies } = this.props;
    const {
      expirationName,
      expirationTTL,
      reset: {
        utcHours: resetHours,
        utcMinutes: resetMinutes,
      },
    } = configTempPass;

    if (typeof cookies.get(expirationName) === 'undefined') {
      const { path } = configTVE;
      // Set tempPass expiration date
      const expires = new Date();
      expires.setUTCHours(resetHours);
      expires.setUTCMinutes(resetMinutes);
      if (new Date() > expires) {
        expires.setUTCDate(expires.getUTCDate() + 1);
      }
      // Set tempPass expiration value
      const expirationValue = (new Date()).getTime() + expirationTTL;
      // Set it
      cookies.set(expirationName, expirationValue, { path, expires });
    }
  }

  /**
   * If tempPass is enabled, test selecting as a provider
   */
  tempPassCheck = () => {
    const { cookies, tempPassProviderID } = this.props;

    if (tempPassProviderID) {
      const { path } = configTVE;
      const { checkName, checkTTL } = configTempPass;

      // Set check cookie expiration to prevent rechecking
      const expires = new Date();
      expires.setTime(expires.getTime() + checkTTL);
      cookies.set(checkName, 1, { path, expires });

      // Required before selecting a provider
      window[ACCESS_ENABLER_OBJ].getAuthentication();

      // Inform enabler
      window[ACCESS_ENABLER_OBJ].setSelectedProvider(tempPassProviderID);
    }
  }

  render() {
    return null;
  }
}


export default connect(mapStateToProps)(
  withCookies(TempPass),
);
